import Sentry from 'lib/sentry';

const initialState = {
  highlightedMerchant: [],
  merchants: [],
  merchantDetail: {},
};

const getters = {
  getHighlightedMerchant: (state) => state.highlightedMerchant,
  getMerchants: (state) => state.merchants,
  getMerchantDetail: (state) => state.merchantDetail,
};

const actions = {
  fetchHighlightedMerchant({commit, rootState}) {
    if (rootState.dataServer?.config?.merchants) {
      commit('setHighlightedMerchant', rootState.dataServer.config.merchants);
      return;
    }

    return this.$api
      .getNeoConfig({id: ['edukarier-merchants-config']})
      .then(({data}) => {
        commit('setHighlightedMerchant', data[0].data.merchants);
      })
      .catch((e) => {
        commit('setError', {highlightedMerchant: true}, {root: true});
        Sentry.log('fetchHighlightedMerchant', e);
      })
      .finally(() => {
        commit('setLoading', {highlightedMerchant: false}, {root: true});
      });
  },
  fetchMerchants({commit}) {
    return this.$api
      .getMerchants({deal_type: 'course'})
      .then(({data}) => {
        commit('setMerchantList', data);
      })
      .catch((e) => {
        commit('setError', {merchants: true}, {root: true});
        Sentry.log('fetchMerchants', e);
      })
      .finally(() => {
        commit('setLoading', {merchants: false}, {root: true});
      });
  },
  fetchMerchantDetail({commit}, merchantId) {
    return this.$api
      .getMerchantDetail({id: merchantId})
      .then(({data}) => {
        commit('setMerchantDetail', data);
      })
      .catch((e) => {
        commit('setError', {merchantDetail: true}, {root: true});
        Sentry.log('fetchMerchantDetail', e);
      })
      .finally(() => {
        commit('setLoading', {merchantDetail: false}, {root: true});
      });
  },
};

const mutations = {
  setHighlightedMerchant(state, merchants) {
    state.highlightedMerchant = merchants;
  },
  setMerchantList(state, merchants) {
    const formatedMerchants = merchants.map(({id, name, logo_url}) => ({id, name, image_url: logo_url}));
    state.merchants = formatedMerchants;
  },
  setMerchantDetail(state, merchant) {
    state.merchantDetail = merchant;
  },
  resetMerchantDetail(state) {
    state.merchantDetail = {};
  },
};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
